// extracted by mini-css-extract-plugin
export default {"navButton":"BurgerButton_navButton__nsAcI"};